import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import report from './report';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    report
  }
});

export default store;
